export default angular.module('trackerCapture', [
    'ui.bootstrap',
    'ngRoute',
    'ngCookies',
    'ngSanitize',
    'ngCsv',
    'ngMessages',
    'trackerCaptureServices',
    'trackerCaptureFilters',
    'trackerCaptureDirectives',
    'd2Directives',
    'd2Filters',
    'd2Services',
    'd2Controllers',
    'd2Templates',
    'angularLocalStorage',
    'ui.select',
    'ui.select2',
    'infinite-scroll',
    'sticky',
    'nvd3ChartDirectives',
    'pascalprecht.translate',
    'leaflet-directive',
    'angularCSS'
]);



// WEBPACK FOOTER //
// ./scripts/trackerCaptureModule.js